import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import TableRow from '@mui/material/TableRow';
import Link from '@mui/material/Link';
import TableCell from 'components/TableCell';
import RoomNameWithCapacity from 'components/RoomNameWithCapacity';

import { RoomRatesTableHead_package$key } from '__generated__/RoomRatesTableHead_package.graphql';

type Props = {
  package: RoomRatesTableHead_package$key;
};

const RoomRatesTableHead: FC<Props> = props => {
  const { rooms } = useFragment(
    graphql`
      fragment RoomRatesTableHead_package on Package {
        rooms {
          id

          ...RoomNameWithCapacity_room
        }
      }
    `,
    props.package
  );

  return (
    <TableRow>
      <TableCell center />
      <TableCell center />
      {rooms.map(room => (
        <TableCell center key={room.id}>
          <Link href={`/rooms/${room.id}`}>
            <RoomNameWithCapacity room={room} />
          </Link>
        </TableCell>
      ))}
    </TableRow>
  );
};

export default RoomRatesTableHead;
